module.exports = __webpack_public_path__ + "static/3_section_mockup-eeb7b4aabdf8c2e87030d2130ae5816d.png";